import Vue from 'vue';
import { ActionContext } from 'vuex';

import { IInteractEventTrackerState } from './state';
import InteractEventTracker, { InteractEventTrackerAction } from '../entities/InteractEventTracker';
import { IInteractEventTrackerAction } from '../entities/IInteractEventTracker';
import { EEligibilityAction } from '@/helpers/enums';
import { EInteractEventTrackerAction } from '../enums/EInteractEventTracker';
import { TInteractEventTrackerActionAction } from '../types/TInteractEventTracker';

export type sendInteractEventFunctionParam = {
  action: IInteractEventTrackerAction['action'],
  attributes?: IInteractEventTrackerAction['attributes'],
  options?: {
    avoidDuplicate?: boolean;
  }
};

const dynamicAttributes = InteractEventTracker.dynamicAttributes;

export default {
  sendInteractEvent({ state, commit }: ActionContext<IInteractEventTrackerState, any>, { action, attributes, options }: sendInteractEventFunctionParam) {
    if (process.env.VUE_APP_MOENGAGE_TOGGLE_FEATURE === 'true') {
      if (
        state.interactEventTracker.actionAlreadyExist &&
        state.interactEventTracker.actionAlreadyExist(action) &&
        options && options.avoidDuplicate
      ) return;

      const interactEventAction = new InteractEventTrackerAction({ action, attributes });

      commit('sendInteractEvent', interactEventAction);
    }
  },
  initInteractBehavior({ state, rootGetters, rootState, dispatch }: ActionContext<IInteractEventTrackerState, any>) {
    let watchDynamicAttributes: any = [];
    dynamicAttributes.forEach((attributeName: string) => {
      watchDynamicAttributes[attributeName] = {
        handler: (value: any) => {
          if (attributeName === 'customer_id') {
            return state.interactEventTracker.customer_id = value;
          }

          Object.keys(EInteractEventTrackerAction).forEach((action: TInteractEventTrackerActionAction) => {
            if (state.interactEventTracker.updateActionAttribute) {
              if (attributeName === 'is_order_form_checkout') {
                value = Boolean(value);
              }

              state.interactEventTracker.updateActionAttribute(action, attributeName, value);
            }
          });
        },
      };
    });

    const dynamicAttributesBus = new Vue({
      computed: {
        cart_uuid: () => rootGetters['App/Checkout/cartUuid'],
        customer_id: () => rootGetters['App/Customer/actaId'],
        offer_id: () => rootGetters['App/Checkout/selectedOffer'].id,
        offer_category: () => rootGetters['App/Checkout/selectedOffer'].category,
        is_order_form_checkout: () => rootGetters['App/Checkout/customTemplateGuid'],
        selected_offer_eligibility: () => rootGetters['App/Checkout/selectedOfferEligibility'],
        is_loading: () => rootState.App.isPageLoading || rootState.App.Checkout.loading,
        is_failed_renewal_redirect() {
          return !window.location.href.includes('renovar') &&
            this.selected_offer_eligibility && this.selected_offer_eligibility.eligible_action === EEligibilityAction.earlyRenewal;
        },
      },
      watch: {
        ...watchDynamicAttributes,
        is_loading: {
          handler(isLoading: boolean) {
            if (!isLoading && this.is_failed_renewal_redirect) {
              dispatch('sendInteractEvent', {
                action: EInteractEventTrackerAction.CHK_RENEWAL_REDIRECT,
              });
            }
          },
        },
      },
    });
  }
};
